import SmallCard from 'components/cards/SmallCard';
import Area from 'models/Area';
import React from 'react';

const AreaCard = ({ area }: { area: Area }) => {
    return (
        <SmallCard
            image={{ url: area.featured_image?.conversions?.thumb?.url || '/images/poi-card-fallback-image.jpg' }}
            alt={area.name}
            link={`/destinacija/${area.slug}`}
        >
            <h1 className="text-xl text-left">{area.name}</h1>
            {area.parent && <h2 className="font-sans text-sm font-semibold text-left">{area.parent.name}</h2>}

            <div className="py-3">
                <p className="text-sm font-light text-left">
                    Idej za izlet <br />
                    <span className="text-sm font-bold">{area.pois_count}</span>
                </p>
            </div>
        </SmallCard>
    );
};

export default AreaCard;
